<template>
    <div class="">
        <div class="room__collapse accordion" id="accordionExample">
            <div class="card" style="overflow: visible">
                <div class="card-header p-0" id="headingOne">
                    <button class="room__collapse__header" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                        Associates Advanced Search
                        <svg xmlns="http://www.w3.org/2000/svg" width="9.414" height="5.414" viewBox="0 0 9.414 5.414" class="arrow__collapsible">
                        <g id="Grupo_6049" data-name="Grupo 6049" transform="translate(8.707 4.707) rotate(180)">
                            <line id="Línea_794" data-name="Línea 794" x2="4" y2="4" transform="translate(4)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                            <line id="Línea_795" data-name="Línea 795" x1="4" y2="4" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1"/>
                        </g>
                        </svg>
                    </button>
                </div>
                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                    <div class="card-body">
                        <h1 class="view__title title--1" v-html="title_page"/>
                        <LocalFormSearch
                        :form_data="form_data"
                        :array_options="array_options"
                        @resetList="resetList"
                        @debounceInput="debounceInput"
                    />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-12">
            <v-card>
                <DinamicTableInfiniteLoader
                    :name="'AdvancedSearch'"
                    :selectable_columns="true"
                    :array_options_table="(use_parent) ? parent_array_options_table : array_options_table"
                    :headers="(table_headers && table_headers.length) ? table_headers : local_table_headers"
                    :items="(use_parent) ? parent_associates :associates"
                    :pagination="(use_parent) ? parent_pagination :pagination"
                    :search="search"
                    :checkable="true"
                    :link="child_href"
                    :size="30"
                    :historiable="historiable"
                    :updateable="updateable"
                    :detail_text="detail_text"
                    @emitLinkAction=" $emit('emitLinkAction', $event)"
                    @emitToUpdate="$emit('modal_update', $event)"
                    @fetchMainList="fetchMainList($event)"
                    @paginateMoreRecords="paginateMoreRecords($event)"
                    ref="main_table"
                />
            </v-card>
        </div>

        <WaitingModal v-if="checkeable === undefined && !checkeable"/>
    </div>
</template>

<script>

import Resources        from    '@/components/AssociateComponent/Associates/AdvancedSearch/resources'
import FormResources    from    '@/components/AssociateComponent/Associates/AdvancedSearch/form_resources'
import WaitingModal     from    '@/components/WaitingModal'
import DinamicTableInfiniteLoader     from    '@/components/DinamicTableInfiniteLoader'
import LocalFormSearch  from    './LocalFormSearch'
import Methods          from    './methods'
import { Notyf }        from    'notyf'
import _ from 'lodash'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'AssociateAdvancedSearch',

    props:[
        'parent_associates',
        'parent_pagination',
        'parent_array_options_table',
        'use_parent',
        'detail_text',
        'checkeable',
        'rest_api',
        'rest_api_pagination',
        'historiable',
        'updateable',
        'table_headers',
        'search',
        'show_sq_ft',
        
    ],

    components:{
        WaitingModal,
        LocalFormSearch,
        DinamicTableInfiniteLoader,
    },

    mixins:[
        Methods,
    ],

    data(){
        return{
            notyf,
            title_page:                 'Advanced search',
            child_href:                 '/associates-detail/',
            rest_api_search:            'associates_advanced_search',
            local_table_headers:        Resources.table_headers,
            breadcrumb:                 Resources.breadcrumb,
            form_data:                  FormResources.form_data,
            associates:                      [],
            array_options:              {},
            selectAll:                  false,
            pagination: null,
            array_options_table: []

        }
    },

    methods:{

        debounceInput:  _.debounce(function (e)  {
            this.form_data[e.field] = e.value
        },800),


        checkingOrigins(associates_origin_id)
        {
            associates_origin_id.forEach(origin_id => 
            {
                let indexFound = this.associates.findIndex(room => room.origin_id === origin_id)
                
                if(indexFound > -1)
                {
                    this.associates[indexFound].checked = true
                    window.$(`#advancedItems${indexFound}`).prop('checked', true)
                }
            })
        },
        replacingAssociates(associates, search_key = 'origin_id')
        {
            associates.forEach(updated_room => {

                let found_index = this.associates.findIndex(room => room[search_key] === updated_room[search_key])
                if(found_index > -1)
                {
                    updated_room.checked = true;
                    this.associates.splice(found_index, 1, updated_room)
                }
            })
        },

        async paginateMoreRecords(params)
        {
            if(this.use_parent)
            {
                this.$emit('paginateMoreRecordsParent', params)

                return;
            }

            if(this.associates.length >= this.pagination?.total)
            {
                return;
            }
            
            await this.showLoader()

            await this.apiRequest(params)
        },

        async fetchMainList(params) 
        {
            if(this.use_parent)
            {
                this.$emit('fetchMainListParent', params)

                return;
            }
            this.associates = [];
            await this.showLoader()
            await this.apiRequest(params, true)
        },


        async loadMoreRecords(data, reset_list)
        {
            if(reset_list)
            {
                this.associates = []
            }

            if(data.pagination.data.length)
            {
                data.pagination.data.forEach((item) => {
                    item.checked = this.$refs.main_table.select_all
                    this.associates.push(item)
                })
            }
            this.pagination = data.pagination

            await this.hideLoader(data.pagination.data)
        },

        isSelectAll()
        {
            return this.$refs.main_table.select_all
        },

        async showLoader()
        {
            this.$refs.main_table.showLoader()
        },

        async hideLoader(data)
        {
            this.$refs.main_table.hideLoader(data)
        }



    },

    async mounted()
    {
        if(this.hasPermissions(['Associate Read','Associate Write', 'Associate Associate-Upload']))
        {
            FormResources.form_data.status_id.push( {
                id: 1, 
                name: 'Active'
            })
            // await this.paginateMoreRecords({page: 1})
        }

        if(this.hasPermissions(['Associate Read','Associate Write', 'Associate Associate-Upload']))
        {
            await this.api_request()
        }
    }

}

</script>